<script setup lang="ts">
defineProps({
  show: Boolean,
  message: {
    default() {
      return 'O arquivo está sendo salvo';
    },
  },
});
</script>

<template>
  <div class="modal modal-sm" :class="{ active: show }">
    <div class="modal-overlay"></div>
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-title h5">Só um momento!</div>
      </div>
      <div class="modal-body">
        <div class="content">
          <p>{{ message }}</p>
          <progress class="progress" max="100"></progress>
        </div>
      </div>
    </div>
  </div>
</template>
